import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { Link, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { update, reset } from 'actions/office-settings/update';
import { Form, Grid, Header } from 'semantic-ui-react';
import { EssorButton } from 'components';
import { withTranslation } from 'react-i18next';

class ContactInformation extends Component {
  state = {
    value: {
      streetName: '',
      additional: '',
      zipCode: '',
      city: '',
      country: '',
      phone: '',
      fax: '',
      website: '',
    },
    streetNameError: false,
    additionalError: false,
    zipCodeError: false,
    cityError: false,
    countryError: false,
    phoneError: false,
    faxError: false,
    websiteError: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      !isEmpty(nextProps.retrievedSetting)
      && nextProps.retrievedSetting['hydra:member'][0]['@id'] !== prevState.id
      && nextProps.retrievedSetting['hydra:member'][0].name === 'CONTACT_INFORMATION'
    ) {
      return {
        id: nextProps.retrievedSetting['hydra:member'][0]['@id'],
        value: nextProps.retrievedSetting['hydra:member'][0].value,
      };
    }

    return null;
  }

  componentWillUnmount() {
    const { reset } = this.props;
    reset();
  }

  handleInputChange = (e) => {
    e.preventDefault();

    const { name, value } = e.target;

    this.setState(prevState => (
      {
        value: {
          ...prevState.value,
          [name]: value,
        },
      }
    ));
  };

  handleOnSubmit = (e) => {
    e.preventDefault();

    const { value } = this.state;

    const { update, retrievedSetting } = this.props;

    const data = {
      value,
    };

    update(retrievedSetting['hydra:member'][0], data);
  };

  render() {
    const {
      id,
      streetNameError,
      additionalError,
      zipCodeError,
      cityError,
      countryError,
      phoneError,
      faxError,
      websiteError,
      value: {
        streetName,
        additional,
        zipCode,
        city,
        country,
        phone,
        fax,
        website,
      },
    } = this.state;

    const {
      retrieveLoading,
      selectedOffice,
      updated,
      updateLoading,
      office,
      match,
      t,
    } = this.props;

    if (updated && office && id) {
      return (
        <Redirect
          push
          to={{
            pathname: `/offices/${match.params.id}/settings/company-details/edit`,
            office,
          }}
        />
      );
    }

    if (updated && !office && id) {
      return (
        <Redirect
          push
          to={`/offices/${match.params.id}/settings/contact-information`}
        />
      );
    }

    return (
      <div className="section-container">
        <div className="section-general">
          <div className="option-buttons-container clearfix">
            <Header as="h3">
              {office && `${t('step')} 2 / 6: `}
              {t('officesContactInformation')}
            </Header>
            {!office
              && (
                <EssorButton as={Link} to={`/offices/${selectedOffice.id}/settings/contact-information`} type="edit" size="tiny" floated="right">
                  {t('buttonBack')}
                </EssorButton>
              )}
          </div>

          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>
                <Form className="margin-top-bot main-form" loading={retrieveLoading || updateLoading} size="small">
                  <Form.Group inline>
                    <Form.Input
                      label={t('formStreetName')}
                      name="streetName"
                      placeholder={t('formPHStreetName')}
                      value={streetName}
                      onChange={this.handleInputChange}
                      error={streetNameError}
                    />
                  </Form.Group>
                  <Form.Group inline>
                    <Form.Input
                      label={t('formAdditional')}
                      name="additional"
                      placeholder={t('formPHAdditional')}
                      value={additional}
                      onChange={this.handleInputChange}
                      error={additionalError}
                    />
                  </Form.Group>

                  <Form.Group inline>
                    <Form.Input
                      label={t('formZipCode')}
                      name="zipCode"
                      placeholder={t('formPHZipCode')}
                      value={zipCode}
                      onChange={this.handleInputChange}
                      error={zipCodeError}
                    />
                  </Form.Group>
                  <Form.Group inline>
                    <Form.Input
                      label={t('formCity')}
                      name="city"
                      placeholder={t('formPHCity')}
                      value={city}
                      onChange={this.handleInputChange}
                      error={cityError}
                    />
                  </Form.Group>

                  <Form.Group inline>
                    <Form.Input
                      label={t('formCountry')}
                      name="country"
                      placeholder={t('formPHCountry')}
                      value={country}
                      onChange={this.handleInputChange}
                      error={countryError}
                    />
                  </Form.Group>

                  <Form.Group inline>
                    <Form.Input
                      label={t('formPhoneNumber')}
                      name="phone"
                      placeholder={t('formPHPhoneNumber')}
                      value={phone}
                      onChange={this.handleInputChange}
                      error={phoneError}
                    />
                  </Form.Group>
                  <Form.Group inline>
                    <Form.Input
                      label={t('formFax')}
                      name="fax"
                      placeholder={t('formPHFax')}
                      value={fax}
                      onChange={this.handleInputChange}
                      error={faxError}
                    />
                  </Form.Group>

                  <Form.Group inline>
                    <Form.Input
                      label={t('formWebsite')}
                      name="website"
                      placeholder="www.example.com"
                      value={website}
                      onChange={this.handleInputChange}
                      error={websiteError}
                    />
                  </Form.Group>

                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <div className="clearfix">
            <EssorButton type="check" onClick={this.handleOnSubmit} size="tiny" floated="right">
              {office ? t('buttonNext') : t('buttonSubmit')}
            </EssorButton>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  update: (item, values) => dispatch(update(item, values)),
  reset: () => {
    dispatch(reset());
  },
});

const mapStateToProps = state => ({
  updateError: state.officeSettings.update.updateError,
  updateLoading: state.officeSettings.update.updateLoading,
  updated: state.officeSettings.update.updated,

  retrievedSetting: state.officeSettings.show.retrieved,
  selectedOffice: state.userCompanies.select.selectedOffice,
});

const Main = connect(mapStateToProps, mapDispatchToProps)(ContactInformation);

export default withTranslation()(withRouter(Main));
